__turbopack_context__.v({
  "signInBtn": "ProtectedFeature-module__oEQl5a__signInBtn",
});
